import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutation'
import actions from './action'

Vue.use(Vuex)

const state = {
	user: null,
	invitationVisible:false
}

const getters = {
	user(state) {
		return state.user;
	}
}



export default new Vuex.Store({
	state,
	getters,
	mutations,
	actions,
	strict: process.env.NODE_ENV !== 'production',
})
